export default function currencyFormat (val: number | String ) : String {
	return (new Intl.NumberFormat()).format(String(val))
}
